import React from 'react'
import { CircularProgress } from '@mui/material'

import useStyles from './styles'

const Loading = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <CircularProgress className={classes.loading} />
    </div>
  )
}

export default Loading
